import type { AiChat } from 'src/@types/ai';
import { create } from 'zustand';

interface ChatIAState {
  // Add state properties here as needed
  currentConversation: AiChat | undefined;
  conversationListOpen: boolean;
}

interface ChatIAActions {
  setCurrentConversation: (conversation: AiChat | undefined) => void;
  setConversationListOpen: (open: boolean) => void;
}

export const chatIAState = create<ChatIAState & ChatIAActions>((set) => ({
  currentConversation: undefined,
  conversationListOpen: true,
  setCurrentConversation: (conversation) =>
    set({ currentConversation: conversation }),
  setConversationListOpen: (open) => set({ conversationListOpen: open }),
}));
